import R from "ramda";
import { useSelector } from "react-redux";

import { usePersonFacesActions } from "store/PersonFacesSlice";

const usePersonFaces = () => {
  const { loadPersonFaces, resetPersonFaces, removePersonFace, deletePersonFace } = usePersonFacesActions();

  const { faces: personFaces, meta } = useSelector((state) => state.PersonFacesSlice);

  const removePersonFaceAttributes = (personFace) => {
    return {
      data: {
        attributes: {
          asset: personFace.asset,
          "created-at": personFace.createdAt,
          default: Boolean(personFace.default),
        },
        id: personFace.id,
        relationships: { person: { data: null } },
        type: "heads",
      },
    };
  };

  return {
    loadPersonFaces,
    resetPersonFaces,
    deletePersonFace,
    removePersonFace: (personFace) => {
      const params = removePersonFaceAttributes(personFace);
      return removePersonFace(personFace.id, params);
    },
    personFaces,
    totalPersonFacesCount: R.propOr(personFaces.count, "totalCount", meta),
  };
};

export default usePersonFaces;
